"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _RangeSliderHandle = _interopRequireDefault(require("./RangeSliderHandle"));

var RangeSlider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RangeSlider, _Component);

  function RangeSlider() {
    var _getPrototypeOf2, _context;

    var _this;

    (0, _classCallCheck2.default)(this, RangeSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RangeSlider)).call.apply(_getPrototypeOf2, (0, _concat.default)(_context = [this]).call(_context, args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderRangeSliderHandle", function (handleProps) {
      var _this$props = _this.props,
          currentLabelPrefix = _this$props.currentLabelPrefix,
          currentLabelSuffix = _this$props.currentLabelSuffix;
      delete handleProps.ref;
      return _react.default.createElement(_RangeSliderHandle.default, (0, _extends2.default)({
        prefix: currentLabelPrefix,
        suffix: currentLabelSuffix
      }, handleProps));
    });
    return _this;
  }

  (0, _createClass2.default)(RangeSlider, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          min = _this$props2.min,
          minLabel = _this$props2.minLabel,
          max = _this$props2.max,
          maxLabel = _this$props2.maxLabel,
          step = _this$props2.step,
          defaultValue = _this$props2.defaultValue,
          onChange = _this$props2.onChange,
          onAfterChange = _this$props2.onAfterChange;
      var classes = (0, _classnames.default)('RangeSlider', className);
      var defaultValueOptimized = defaultValue ? defaultValue : Math.round((min + max) / 2);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_rcSlider.default, {
        min: min,
        max: max,
        step: step,
        defaultValue: defaultValueOptimized,
        handle: this._renderRangeSliderHandle,
        onChange: onChange,
        onAfterChange: onAfterChange
      }), minLabel && _react.default.createElement("span", {
        className: "RangeSlider-min-value"
      }, minLabel), maxLabel && _react.default.createElement("span", {
        className: "RangeSlider-max-value"
      }, maxLabel));
    }
  }]);
  return RangeSlider;
}(_react.Component);

exports.default = RangeSlider;
(0, _defineProperty2.default)(RangeSlider, "defaultProps", {
  min: 0,
  max: 100,
  step: 1
});